import { render, staticRenderFns } from "./getMargin.vue?vue&type=template&id=215a613f&"
import script from "./getMargin.vue?vue&type=script&lang=js&"
export * from "./getMargin.vue?vue&type=script&lang=js&"
import style0 from "./getMargin.vue?vue&type=style&index=0&id=215a613f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports